<template>
  <div style="width: 100%;height: 100%;overflow: hidden !important;position: absolute;">
    <div style="width: 100%;height: 100vh;overflow-y: scroll;padding-bottom: 100px;">
      <List v-if="formStatus == 'list'" :role="role" :page="page"
            @addCallbackMsg="handleViewMsg" @addCallbackTask="handleViewTask"
            @addCallbackTaskList="handleViewTaskList"></List>
      <MsgDetail v-if="formStatus == 'msg'" :item="item" :page="page" :audit="audit" :type="type" :store-id="storeId" :role="role" :turn-type="turnType"
                 @addCallbackMsg="handleViewMsg" @addCallbackTask="handleViewTask" @back="back"></MsgDetail>
      <TaskDetail v-if="formStatus == 'task'" :item="item" :page="page" :type="type" :audit="audit" :role="role" :return="returnIn"
                  @addCallbackMsg="handleViewMsg" @addCallbackTask="handleViewTask" :search-data="searchData"
                  @addCallbackTaskList="handleViewTaskList"
                  @back="back"></TaskDetail>
      <TaskAllList v-if="formStatus == 'taskList'" :page="page" :item="item" :role="role" :search-data="searchData"
                   @addCallbackTaskList="handleViewTaskList" @addCallbackTask="handleViewTask"
                   @back="back"></TaskAllList>
    </div>
  </div>
</template>

<script>
import List from "@/views/alarm/workbench/messageList";
import MsgDetail from "@/views/alarm/workbench/messageDetails";
import TaskDetail from "@/views/alarm/workbench/taskDetails";
import TaskAllList from "@/views/alarm/workbench/taskAllList";
import AlarmOrderApi from "../../../api/alarm/order/AlarmOrderApi";
import {default as PermissionApi} from "@/api/smp/auth/Permission";
export default {
  name: "benchInfo",
  components: {List, MsgDetail, TaskDetail, TaskAllList},
  data() {
    return {
      formStatus: 'list',
      item: null,
      type: 0,
      storeId: "",
      role: 0,
      userInfo: [],
      returnIn: 1,
      page: {
        closable: true,
        compPath: "/alarm/workbench/benchInfo.vue",
        icon: null,
        id: "962",
        routeName: "null",
        tabId: "menu_962",
        title: "预警指标",
        roleId: ''
      },
      buttonPriviledgeList: [],
      roleId: '',
      audit: 0,
      turnType: 0,
      searchData: null
    }
  },
  created() {
    this.getButtonPriviledge()
    this.getUserInfo()
  },
  mounted() {

  },
  methods: {
    // 获取用户信息
    async getUserInfo() {
      let that = this
      await AlarmOrderApi.getUserInfo({userId: -1}).then(res => {
        console.log(res);
        res = res.data
        if (res.code == 200) {
          let userInfo = res.data
          if (userInfo.id != undefined && userInfo.id != null) {
            that.page.roleId = userInfo.id
            if (userInfo.id == 1 || userInfo.id == 2 || userInfo.id == 5 || userInfo.id == 7) {
              that.role = 2
            } else if (userInfo.id == 6) {
              that.role = 1
            } else if (userInfo.id == 3 || userInfo.id == 4) {
              that.role = 3
            } else {
              alert('暂无权限查看此页面')
              return false
            }
          } else {
            alert('暂无权限查看此页面')
            return false
          }
          console.log(that.role)
        }
      })
    },
    handleViewMsg(data){
      console.log(data)
      this.formStatus = 'msg';
      this.item = data.item;
	  this.audit = data.audit;
	  this.type = data.type;
      this.turnType = data.turnType != null && data.turnType != undefined ? data.turnType : 0;
      if (this.item.deptCode != null) {
        let deptCode = this.item.deptCode
        let storeId = deptCode.slice(0, 2)
        this.storeId = storeId
      } else {
        this.storeId = ""
      }
    },
    handleViewTask(data){
      console.log(data)
      this.formStatus = 'task';
      this.item = data.item;
      this.type = data.type
      this.audit = data.audit != null && data.return != undefined && data.audit != '' ? data.audit : 0
      this.returnIn = data.return != null || data.return != undefined ? data.return : 1
      this.searchData = data.searchData
    },
    handleViewTaskList(data) {
      this.formStatus = 'taskList';
      this.item = data.item;
      this.searchData = data.searchData
    },
    back(){
      this.formStatus='list';
    },
    getButtonPriviledge(){
      console.log('this.page',this.page)
      let menuId = this.page.id
      let me = this
      PermissionApi.queryButtonPriviledge(menuId,null).then(resp=>{
        PermissionApi.handleResponse(resp, me, function (data){
          me.buttonPriviledgeList = data.buttonPriviledges
          console.log('buttonPriviledgeList',me.buttonPriviledgeList)
        })
      })
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton = false
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == 'Y') {
            return true
          } else {
            return false
          }
        }
      }
      return false
    }
  }
}
</script>

<style scoped>

</style>